export enum BundleAssignmentTypes {
    GET_DASHBOARD_LOADING = "GET_DASHBOARD_LOADING",
    GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS",
    GET_DASHBOARD_FAILURE = "GET_DASHBOARD_FAILURE",

    CREATE_LOTE_LOADING = "CREATE_LOTE_LOADING",
    CREATE_LOTE_SUCCESS = "CREATE_LOTE_SUCCESS",
    CREATE_LOTE_FAILURE = "CREATE_LOTE_FAILURE",

    SUBMIT_REVISION_LOADING = "SUBMIT_REVISION_LOADING",
    SUBMIT_REVISION_SUCCESS = "SUBMIT_REVISION_SUCCESS",
    SUBMIT_REVISION_FAILURE = "SUBMIT_REVISION_FAILURE",

    APPROVE_LOTE_LOADING = "APPROVE_LOTE_LOADING",
    APPROVE_LOTE_SUCCESS = "APPROVE_LOTE_SUCCESS",
    APPROVE_LOTE_FAILURE = "APPROVE_LOTE_FAILURE",

    SET_SELECTED_LOTE = "SET_SELECTED_LOTE",
}
